import { React } from 'react';
import styled from 'styled-components';

import { useLanguage } from '../../../Context/LanguageContext';

import TopBar from './TopBar';
import LocationButton from './LocationButton';

function LocationModel() {
  const { t } = useLanguage();

  return (
    <TopLevelWrapper>
      <TopBar/>
      <BottomWrapper>
        <LocationButton nowPage={'Location'} />
        <TextWrapper>
          <Title style={{ marginTop: `38px` }}>{t('rules.location.t1')}</Title>
          <Text style={{ marginTop: `14px` }}>
            {t('rules.location.p1')}
          </Text>

          <Title style={{ marginTop: `14px` }}>{t('rules.location.t2')}</Title>
          <Text>
            {t('rules.location.p2')}
          </Text>

          <Title style={{ marginTop: `38px` }}>{t('rules.location.t3')}</Title>
          <Text>
            {t('rules.location.p3')}
          </Text>

          <Title style={{ marginTop: `38px` }}>{t('rules.location.t4')}</Title>
          <Text>
            {t('rules.location.p4')}
          </Text>
          <Text style={{ marginTop: `14px` }}>
            {t('rules.location.p5')}
          </Text>
          <Text>
            {t('rules.location.p6')}
          </Text>
          <Text>
            {t('rules.location.p7')}
          </Text>
          <Text>
            {t('rules.location.p8')}
          </Text>
          <Text>
            {t('rules.location.p9')}
          </Text>
          <Text>
            {t('rules.location.p10')}
          </Text>
          <Text>
            {t('rules.location.p11')}
          </Text>
          <Text>
            {t('rules.location.p12')}
          </Text>
          <Text style={{ marginTop: `14px` }}>
            {t('rules.location.p13')}
          </Text>

          <Title style={{ marginTop: `38px` }}>{t('rules.location.t5')}</Title>
          <Text>
            {t('rules.location.p14')}
          </Text>
          <Text>
            {t('rules.location.p15')}
          </Text>
          <Text>
            {t('rules.location.p16')}
          </Text>
          <Text>
            {t('rules.location.p17')}
          </Text>
          <Text style={{ marginTop: `14px` }}>
            {t('rules.location.p18')}
          </Text>
          <Text>
            {t('rules.location.p19')}
          </Text>
          <Text style={{ marginTop: `14px` }}>
            {t('rules.location.p20')}
          </Text>
          <Text>
            {t('rules.location.p21')}
          </Text>

          <Title style={{ marginTop: `38px`}}>{t('rules.location.t6')}</Title>
          <Text>
            {t('rules.location.p22')}
          </Text>
          <Text>
            {t('rules.location.p23')}
          </Text>

          <Title style={{ marginTop: `38px` }}>{t('rules.location.t7')}</Title>
          <Text>
            {t('rules.location.p24')}
          </Text>

          <Title style={{ marginTop: `38px` }}>{t('rules.location.t8')}</Title>
          <Text>
            {t('rules.location.p25')}
          </Text>
          <Text>
            {t('rules.location.p26')}
          </Text>

          <Title style={{ marginTop: `38px` }}>{t('rules.location.t9')}</Title>
          <Text>
            {t('rules.location.p27')}
          </Text>
          <Text>
            {t('rules.location.p28')}
          </Text>
          <Text>
            {t('rules.location.p29')}
          </Text>
          <Text>
            {t('rules.location.p30')}
          </Text>
          <Text>
            {t('rules.location.p31')}
          </Text>

          <Title style={{ marginTop: `38px` }}>{t('rules.location.t10')}</Title>
          <Text>
            {t('rules.location.p32')}
          </Text>
          <Text>
            {t('rules.location.p33')}
          </Text>
          <Text>
            {t('rules.location.p34')}
          </Text>
          <Text>
            {t('rules.location.p35')}
          </Text>
          <Text>
            {t('rules.location.p36')}
          </Text>
          <Text>
            {t('rules.location.p37')}
          </Text>

          <Title style={{marginTop: `38px`}}>{t('rules.location.t11')}</Title>
          <Text>
            {t('rules.location.p38')}
          </Text>

          <Title style={{ marginTop: `38px` }}>{t('rules.location.t12')}</Title>
          <Text>
            {t('rules.location.p39')}
          </Text>
          <Text>
            {t('rules.location.p40')}
          </Text>

          <Title style={{ marginTop: `38px` }}>{t('rules.location.t13')}</Title>
          <Text>
            {t('rules.location.p41')}
          </Text>
          <Text>
            {t('rules.location.p42')}
          </Text>
          <Text>
            {t('rules.location.p43')}
          </Text>
          <Text>
            {t('rules.location.p44')}
          </Text>

          <Title style={{ marginTop: `38px` }}>{t('rules.location.t14')}</Title>
          <Bold>{t('rules.location.b1')}</Bold>
          <Text>
            {t('rules.location.p45')}
          </Text>

          <Bold style={{ marginTop: `14px`}}>{t('rules.location.b2')}</Bold>
          <Text>
            {t('rules.location.p46')}
          </Text>
          <Text>
            {t('rules.location.p47')}
          </Text>
          <Text style={{ marginBottom: `110px` }}>
            {t('rules.location.p48')}
          </Text>
        </TextWrapper>
      </BottomWrapper>
    </TopLevelWrapper>
  )
}

export default LocationModel;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 100%;

  background-color: ${props => props.theme.background};
`;

const BottomWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 1194px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 14px;

  color: ${props => props.theme.primary};

  margin: 0 0 0 0;
`;

const Bold = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 14px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
`;

const Text = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
`;
